import React from 'react';
import { NewsCard } from './NewsCard';
import Link from 'next/link';
import { useRouter } from 'next/router';
import {
  Order_By,
  useGetNewsCategoriesBySlugQuery,
  useNewsHomepageQuery,
} from '@/generated/graphql';
import { UrlLink } from '@/configs/urlLink';

export function NewsCategoryVerticalSection() {
  const router = useRouter();

  const { data: DataDetailCategory } = useGetNewsCategoriesBySlugQuery({
    variables: {
      where: {
        slug: {
          _like: router?.query?.slug?.toString() || '',
        },
      },
    },
  });

  const { data } = useNewsHomepageQuery({
    variables: {
      limit: 5,
      orderBy: {
        update_at: Order_By.Desc,
      },
      where: {
        news_category: {
          id: { _neq: DataDetailCategory?.news_category?.[0]?.id },
        },
        is_public: {
          _eq: true,
        },
      },
    },
  });

  return (
    <div className="pb-8">
      <div className="border-b pb-4">
        <div className="flex items-center gap-1 md:px-[10px] lg:px-0">
          <Link href={UrlLink.news.news}>
            <h2 className="text-primary md:text-bold text-PC-Display-H5 font-header">
              Xem thêm tin khác
            </h2>
          </Link>

          <div className="flex h-6 w-6 items-center justify-center">
            <svg
              width="8"
              height="15"
              viewBox="0 0 8 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 13.5L7 7.5L1 1.5"
                stroke="#020509"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-4">
        {data?.news?.map((item, index) => {
          if (index === 0)
            return (
              <div className="mt-4 border-b pb-2" key={item.id}>
                <NewsCard
                  src={item?.thumbnail}
                  size="default"
                  variant="vertical"
                  title={item?.title}
                  link={`/tin-tuc/${item?.slug}-${item?.id}`}
                  // sub_link={`/news/${item?.news_category?.slug}`}
                />
              </div>
            );
          return (
            <div className="border-b pb-2" key={item.id}>
              <NewsCard
                size="default"
                title={item?.title}
                variant="vertical"
                // tag={item?.news_category?.name}
                link={`/tin-tuc/${item?.slug}-${item?.id}`}
                // sub_link={`/news/${item?.news_category?.slug}`}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
